'use strict';
angular.module('mediaSelectorModule').directive('imgPersonTips', ['$q', '$timeout',
    function($q, $timeout) {
        return {
            scope: {
                personTips: '=', // 人物标签
                place: '@', // 用来表明当前是编辑（edit）还是查看详情（detail）
            },
            restrict: 'E',
            replace: true,
            templateUrl: './components/util/trsMediaSelector/derective/presonTip/presonTip.html',
            link: function($scope) {
                initStatus();

                /**
                 * [initStatus description] 初始化状态
                 *
                 * @return {[type]}   [return description]
                 */
                function initStatus() {
                    $scope.data = {
                        showNum: 3
                    };
                }

                // 删除人物标签
                $scope.deleteTip = function(index) {
                    $scope.personTips.splice(index, 1);
                };
            }
        };
    }
]);
